import React from 'react';

import { Group, GroupProps } from '@mantine/core';
import { useId } from '@mantine/hooks';

import { Draggable } from '../../../DragAndDrop';
import { DraggableHandle, DraggableHandleProps } from './DraggableHandle';

type DraggableWrapperProps = {
  children: React.ReactNode;
  index: number;
  /**
   * Draggable needs a unique id, preferable not an index
   */
  draggableId?: string;
  handleProps?: Omit<DraggableHandleProps, 'provided'>;
  groupProps?: GroupProps;
};

const DraggableWrapper = ({
  children,
  index,
  groupProps,
  handleProps,
  draggableId,
}: DraggableWrapperProps) => {
  const uuid = useId(draggableId);
  return (
    <Draggable index={index} draggableId={uuid}>
      {(provided) => (
        <Group
          wrap="nowrap"
          gap="sm"
          style={{ flexGrow: 1 }}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...groupProps}
        >
          <DraggableHandle provided={provided} isDraggable {...handleProps} />
          {children}
        </Group>
      )}
    </Draggable>
  );
};

export { DraggableWrapper };
